import { memoize } from 'lodash'

const SUBDOMAINS = {
  api: 'api',
  app: 'app',
  support: 'api.support'
}

const STANDARD_HOSTS = ['app.gremlin.com', 'app.staging.gremlin.com']
// Pattern for a devenv host is app.user-name.devenv.gremlin.com
const DEVENV_PATTERN = /^app\.[^.]*\.devenv\.gremlin\.com$/
// Pattern for a new staging host is
const STAGING_PATTERN = /^app\.[^.]*\.staging\.gremlin\.com$/

class BaseUrlBuilder {
  constructor(windowLocation, key) {
    if (!Object.keys(this.envUrls).includes(key)) {
      throw new Error(`unknown host key ${key}`)
    }
    Object.assign(this, { windowLocation, key })
  }

  // All supported keys must have an env key translation here
  get envUrls() {
    return {
      /* eslint-disable gremlin/no-host-url-env-vars */
      api: process.env.REACT_APP_API_URL,
      app: process.env.REACT_APP_ENVIRONMENT_URL,
      support: process.env.SUPPORT_APP_API_BASE
      /* eslint-enable gremlin/no-host-url-env-vars */
    }
  }

  // Cases where we are allowed to compute the url:
  //  app.gremlin.com
  //  app.staging.gremlin.com
  //  app.*.devenv.gremlin.com
  validateComputable() {
    const { host } = this.windowLocation
    if (STANDARD_HOSTS.includes(host)) return
    if (DEVENV_PATTERN.test(host)) return
    if (STAGING_PATTERN.test(host)) return
    throw new Error(`Cannot compute base host for ${host}`)
  }

  build() {
    // Override based on environment if provided
    if (this.envUrls[this.key]) return this.envUrls[this.key]

    // Ensure that we are able to compute the host for this URL.
    this.validateComputable()

    // Compute based on the location
    const { protocol, host } = this.windowLocation

    // Chop off "app." to get the base host
    const hostBase = host.slice('app.'.length)
    return `${protocol}//${SUBDOMAINS[this.key]}.${hostBase}`
  }
}

// Main function
const getBaseUrl = memoize((key) =>
  new BaseUrlBuilder(window.location, key).build()
)

export { BaseUrlBuilder, getBaseUrl }
